<template>
    <el-dialog class="dia" fullscreen :visible="visible" :show-close="false">
        <div class="aiChat">
            <div class="chat-container">
                <!-- 头部 -->
                <div class="chat-header">
                    <div class="header-left">
                        <h2>飞凡智问</h2>
                    </div>
                    <div class="header-right">
                        <button type="button" @click="closeAIChat" class="close-button">
                            ×
                        </button>
                    </div>
                </div>
                
                <!-- 消息区域 -->
                <div class="chat-messages">
                    <!-- 系统消息 -->
                    <div v-if="msgList.length === 0" class="system-message">
                        你好！我是飞凡智问，有什么可以帮你的吗？
                    </div>
                    
                    <!-- 消息列表 -->
                    <div v-for="(item, index) in msgList" :key="index" class="message-group">
                        <!-- 用户消息 -->
                        <div v-if="item.isUser" class="message user-message">
                            <div class="message-content">
                                {{ item.content }}
                            </div>
                        </div>
                        <!-- AI消息 -->
                        <div v-else class="message ai-message">
                            <div class="message-content" style="padding-left:30px;">
                                <div v-html="parseMarkdown(item.content)"></div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <!-- 输入区域 -->
                <div class="chat-input-area">
                    <div class="input-container">
                        <textarea 
                            v-model="queryMsg" 
                            placeholder="请输入问题..." 
                            class="chat-input" 
                            @keyup.enter.exact="getMsg"
                        ></textarea>
                    </div>
                    <button v-if="isCanSend" type="button" @click="getMsg" class="send-button">
                        <span class="iconfont icon el-icon-top"></span>
                    </button>
                    <div v-else class="send-button">
                        <span class="iconfont icon el-icon-loading"></span>
                    </div>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: 'AiChat',
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            queryMsg: '',
            isCanSend: true,
            msgList: [],
            md: null
        }
    },
    mounted() {
        // 初始化markdown-it
        if (window.markdownit) {
            this.md = window.markdownit({
                html: true,
                linkify: true,
                breaks: true
            });
        }
        // 弹窗打开时滚动到底部
        this.$nextTick(() => {
            this.scrollToBottom();
        });
    },
    methods: {
        // 关闭AI助手弹窗
        closeAIChat() {
            this.$emit('closeAIChat')
        },
        
        // 滚动到底部
        scrollToBottom() {
            this.$nextTick(() => {
                const messagesContainer = document.querySelector('.chat-messages');
                if (messagesContainer) {
                    messagesContainer.scrollTop = messagesContainer.scrollHeight;
                }
            });
        },
        
        parseMarkdown(text) {
            if (!text) return text;
            if (this.md) {
                return this.md.render(text);
            } else {
                return text;
            }
        },
        
        async getMsg() {
            if (!this.queryMsg.trim() || !this.isCanSend) return;
            
            // 添加用户消息
            const userMessage = {
                content: this.queryMsg.trim(),
                isUser: true
            };
            this.msgList.push(userMessage);
            
            // 滚动到底部
            this.scrollToBottom();
            this.isCanSend = false;
            
            // 清空输入框
            const query = this.queryMsg.trim();
            this.queryMsg = '';
            
            try {
                // 添加AI回复占位符
                const aiMessage = {
                    content: '...',
                    isUser: false
                };
                this.msgList.push(aiMessage);
                
                // 滚动到底部
                this.scrollToBottom();
                
                const response = await fetch(`${window.global_config.AI_CHAT_URL}/v1/chat-messages`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${window.global_config.AI_API.CHAT_API_KEY}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        query: query,
                        response_mode: "streaming",
                        user: "abc-123",
                        files: [],
                        inputs: {},
                        conversation_id: "",
                    })
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                
                const reader = response.body.getReader();
                const decoder = new TextDecoder();
                let buffer = '';

                while (true) {
                    const index = this.msgList.length - 1;
                    const { done, value } = await reader.read();
                    if (done) {
                        console.log('流式数据接收完成');
                        break;
                    }

                    buffer += decoder.decode(value, { stream: true });
                    const lines = buffer.split('\n');
                    buffer = lines.pop();

                    lines.forEach(line => {
                        if (line.startsWith('data:')) {
                            const data = line.substring(5).trim();
                            if (data) {
                                try {
                                    const parsedData = JSON.parse(data);
                                    if (parsedData.event == 'message') {
                                        if(this.msgList[index].content == '...') this.msgList[index].content = '';
                                        this.msgList[index].content += parsedData.answer;
                                        // 滚动到底部（实时滚动，确保长消息也能看到最新内容）
                                        this.scrollToBottom();
                                    }
                                } catch (e) {
                                    console.error('解析数据失败:', e);
                                }
                            }
                        }
                    });
                }
            } catch (error) {
                console.error('请求错误:', error);
                // 显示错误消息
                if (this.msgList.length > 0 && !this.msgList[this.msgList.length - 1].isUser) {
                    this.msgList[this.msgList.length - 1].content = '抱歉，请求失败，请稍后重试';
                    // 滚动到底部
                    this.scrollToBottom();
                }
                
            }
            this.isCanSend = true;
        }
    }
}
</script>

<style scoped>
/* 1. 全局基础高度兜底（如果项目全局已设置，可省略） */
:global(html),
:global(body) {
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden; /* 防止全局滚动条 */
}

/* 2. 核心容器：强制100%高度继承 */
.aiChat {
  width: 100%;
  height: 100vh; /* 强制撑满视口高度，优先级高于100% */
  min-height: 100%;
}

.chat-container {
  width: 100%;
  height: 100%; /* 继承父容器100%高度 */
  display: flex;
  flex-direction: column;
  background-color: #f5f5f5;
  color: #333333;
  margin: 0;
  padding: 0;
}

/* 3. 头部样式（无修改，仅保持） */
.chat-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  background-color: #ffffff;
  border-bottom: 1px solid #e0e0e0;
  flex-shrink: 0; /* 防止头部被压缩 */
}
.header-right {
  display: flex;
  align-items: center;
  width: auto;
}
.header-left h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333333;
}

.close-button {
  background: none;
  border: none;
  color: #999999;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.close-button:hover {
  background-color: #f0f0f0;
  color: #666666;
}

/* 4. 消息区域：Flex:1 填充剩余空间，强制撑满 */
.chat-messages {
  flex: 1 1 auto; /* 关键：填充header和input-area之外的所有空间 */
  padding: 20px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 0; /* 配合flex:1，强制触发剩余空间填充（解决部分浏览器兼容） */
}

.system-message {
  align-self: center;
  background-color: #e8e8e8;
  color: #666666;
  padding: 8px 16px;
  border-radius: 16px;
  font-size: 14px;
  margin: 10px 0;
}

.message-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.user-message {
  align-self: flex-end;
  max-width: 70%;
}

.ai-message {
  align-self: flex-start;
  max-width: 70%;
}

.message-content {
  padding: 12px 16px;
  border-radius: 18px;
  line-height: 1.5;
  font-size: 14px;
}

.user-message .message-content {
  background-color: #4a90e2;
  color: #ffffff;
  border-bottom-right-radius: 4px;
}

.ai-message .message-content {
  background-color: #ffffff;
  color: #333333;
  border-bottom-left-radius: 4px;
  border: 1px solid #e0e0e0;
}

/* 5. 输入区域：固定在底部，不压缩 */
.chat-input-area {
  padding: 20px;
  background-color: #ffffff;
  border-top: 1px solid #e0e0e0;
  display: flex;
  gap: 10px;
  align-items: flex-end;
  flex-shrink: 0; /* 防止输入框被压缩 */
}

.input-container {
  flex: 1;
  position: relative;
}

.chat-input {
  width: 100%;
  min-height: 48px;
  max-height: 150px;
  padding: 12px 16px;
  background-color: #f0f0f0;
  border: 1px solid #e0e0e0;
  border-radius: 24px;
  color: #333333;
  resize: none;
  font-size: 14px;
  line-height: 1.5;
  transition: all 0.3s ease;
}

.chat-input:focus {
  outline: none;
  border-color: #4a90e2;
  box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.2);
  background-color: #ffffff;
}

.chat-input::placeholder {
  color: #999999;
}

.send-button {
  background-color: #4a90e2;
  color: #ffffff;
  border: none;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.send-button:hover {
  background-color: #3a80d2;
  transform: scale(1.05);
}

.send-button:active {
  transform: scale(0.95);
}

.send-icon {
  font-size: 18px;
  font-weight: bold;
}

/* 滚动条样式 */
.chat-messages::-webkit-scrollbar {
  width: 6px;
}

.chat-messages::-webkit-scrollbar-track {
  background: #f0f0f0;
  border-radius: 3px;
}

.chat-messages::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.chat-messages::-webkit-scrollbar-thumb:hover {
  background: #a1a1a1;
}

/* Markdown样式 */
.ai-message .message-content h1,
.ai-message .message-content h2,
.ai-message .message-content h3,
.ai-message .message-content h4,
.ai-message .message-content h5,
.ai-message .message-content h6 {
  margin: 16px 0 8px 0;
  font-weight: 600;
  line-height: 1.25;
  color: #333333;
}

.ai-message .message-content h1 {
  font-size: 24px;
}

.ai-message .message-content h2 {
  font-size: 20px;
}

.ai-message .message-content h3 {
  font-size: 18px;
}

.ai-message .message-content p {
  margin: 8px 0;
  line-height: 1.5;
}

.ai-message .message-content ul,
.ai-message .message-content ol {
  margin: 8px 0;
  padding-left: 24px;
}

.ai-message .message-content li {
  margin: 4px 0;
  line-height: 1.5;
}

.ai-message .message-content code {
  background-color: #f6f8fa;
  padding: 2px 4px;
  border-radius: 3px;
  font-family: "Consolas", "Monaco", "Courier New", monospace;
  font-size: 14px;
  color: #e96900;
}

.ai-message .message-content pre {
  background-color: #f6f8fa;
  padding: 12px;
  border-radius: 6px;
  overflow-x: auto;
  margin: 8px 0;
}

.ai-message .message-content pre code {
  background-color: transparent;
  padding: 0;
}

.ai-message .message-content blockquote {
  border-left: 4px solid #4a90e2;
  padding-left: 12px;
  margin: 8px 0;
  color: #666666;
}

.ai-message .message-content a {
  color: #4a90e2;
  text-decoration: none;
}

.ai-message .message-content a:hover {
  text-decoration: underline;
}

.ai-message .message-content img {
  max-width: 100%;
  border-radius: 4px;
  margin: 8px 0;
}

/* 6. 对话框样式：彻底重置Element UI默认样式，确保无留白 */
.dia {
  width: 100vw !important;
  height: 100vh !important;
  margin: 0 !important;
  top: 0 !important;
  left: 0 !important;
  border-radius: 0 !important;
  background-color: transparent !important;
  box-shadow: none !important;
  padding: 0 !important;
}

/* 重置Dialog的wrapper（Element UI的外层容器） */
::v-deep .el-dialog__wrapper {
  width: 100vw !important;
  height: 100vh !important;
  display: flex;
  align-items: stretch; /* 拉伸子元素撑满高度 */
  justify-content: stretch;
  /* background-color: #f5f5f5 !important; */
}

.dia .el-dialog__header {
  display: none;
}

.dia .el-dialog__body {
  padding: 0 !important;
  height: 100% !important;
  max-height: 100vh !important;
  background-color: #f5f5f5;
  overflow: hidden; /* 防止body内部滚动 */
}
</style>